// Where the custom-event dialog sits. It opens beside the point it was placed from — a
// timeline click, or the screen centre for a rejected chat-typed trigger — but always whole
// on screen: on a narrow viewport the anchor-relative box would run off the right edge and
// hide the Branch button, so the box narrows to fit and is clamped inside the viewport.

/** The dialog's content width when there is room (its CSS `width`, content-box). */
const PANEL_WIDTH = 280;
/** Padding (14px each side) plus the 1px border: what content-box adds to `width`. */
const PANEL_CHROME = 30;
const ANCHOR_GAP = 20;
const ANCHOR_LIFT = 80;
const MARGIN = 8;

/**
 * The dialog's fixed-position `left` / `top` / `width`, in the root's zoomed CSS pixels.
 *
 * @param {{screenX:number, screenY:number, uiZoom:number, viewportWidth:number}} args
 *   The anchor and the viewport are screen pixels; dividing by `uiZoom` puts them in the
 *   space the dialog's own `left` / `top` are read in.
 * @returns {{left:number, top:number, width:number}}
 */
export function customEventPopoverBox({ screenX, screenY, uiZoom, viewportWidth }) {
  const zoom = uiZoom > 0 ? uiZoom : 1;
  const viewWidth = viewportWidth / zoom;
  const width = Math.max(0, Math.min(PANEL_WIDTH, viewWidth - 2 * MARGIN - PANEL_CHROME));
  const rightmost = viewWidth - MARGIN - (width + PANEL_CHROME);
  return {
    left: Math.max(MARGIN, Math.min(screenX / zoom + ANCHOR_GAP, rightmost)),
    top: Math.max(MARGIN, screenY / zoom - ANCHOR_LIFT),
    width,
  };
}
